<div [formGroup]="group">
    <!-- <label class="item-sep">Chambre {{ i + 1 }}</label> -->
    <div class="col-to-row-s-mb ctn-baseline">
        <number class="field-sep fix-width-1"
                [labelPosition]="labelPosition"
                [fieldConfig]="{
                formGroup: group,
                formControlName: 'adult',
                min: 0,
                label: Yii.t('wui-shared-js', 'ADT'),
                fixed: 0
            }"></number>
<!--        <number-field-->
<!--            [label]=""-->
<!--            [group]=""-->
<!--            controlName="adult"-->
<!--            styleForm="reverse-row"-->
<!--            class="field-sep fix-width-1"-->
<!--            min="0"></number-field>-->
        <number class="field-sep fix-width-1"
                [labelPosition]="labelPosition"
                [fieldConfig]="{
                formGroup: group,
                formControlName: 'child',
                min: 0,
                label: Yii.t('wui-shared-js', 'CHD'),
                fixed: 0
            }"></number>
<!--        <number-field-->
<!--            [label]="Yii.t('wui-shared-js', 'CHD')"-->
<!--            [group]="group"-->
<!--            controlName="child"-->
<!--            styleForm="reverse-row"-->
<!--            class="field-sep fix-width-1"-->
<!--            min="0"-->
<!--            ></number-field>-->
        <number class="field-sep fix-width-1"
                [labelPosition]="labelPosition"
                [fieldConfig]="{
                formGroup: group,
                formControlName: 'infant',
                min: 0,
                label: Yii.t('wui-shared-js', 'INF'),
                fixed: 0
            }"></number>
<!--        <number-field-->
<!--            [label]="Yii.t('wui-shared-js', 'INF')"-->
<!--            [group]="group"-->
<!--            controlName="infant"-->
<!--            styleForm="reverse-row"-->
<!--            class="field-sep fix-width-1"-->
<!--            min="0"-->
<!--            ></number-field>-->
    </div>
</div>
